import { ROUTES } from '@/_constants';
import { Routes } from '@angular/router';

import { AuthenticationGuard } from './_guards';
import { RoutePathMatch } from './_types';
import { AuthorizationLayoutComponent } from './layouts/authorization/authorization.layout';
import { ErrorLayoutComponent } from './layouts/error/error.layout';
import { AppLayoutComponent } from './layouts/app.layout.component';

export const APP_ROUTES: Routes = [
  {
    path: ROUTES.EMPTY_URL,
    redirectTo: ROUTES.LOGIN.path,
    pathMatch: RoutePathMatch.Full
  },
  {
    path: ROUTES.ADMINISTRATION.path,
    component: AppLayoutComponent,
    children: [
      {
        path: ROUTES.EMPTY_URL,
        loadChildren: () =>
          import('@/features/administration/administration.routes').then((m) => m.ADMINISTRATION_ROUTES)
      }
    ],
    data: {
      title: ROUTES.ADMINISTRATION.name,
      isAdminRoutes: true
    },
    canActivateChild: [AuthenticationGuard]
  },
  {
    path: ROUTES.EMPTY_URL,
    component: AppLayoutComponent,
    children: [
      {
        path: ROUTES.EMPTY_URL,
        loadChildren: () => import('@/features/creator/creator.routes').then((m) => m.CREATOR_ROUTES)
      }
    ],
    data: {
      isAdminRoutes: false
    },
    canActivateChild: [AuthenticationGuard]
  },
  {
    path: ROUTES.REPORTING.path,
    component: AppLayoutComponent,
    children: [
      {
        path: ROUTES.EMPTY_URL,
        loadChildren: () => import('@/features/reporting/reporting.routes').then((m) => m.REPORTING_ROUTES)
      }
    ],
    data: {
      title: ROUTES.REPORTING.label,
      isAdminRoutes: false
    },
    canActivateChild: [AuthenticationGuard]
  },
  {
    path: ROUTES.EMPTY_URL,
    component: AuthorizationLayoutComponent,
    children: [
      {
        path: ROUTES.EMPTY_URL,
        loadChildren: () => import('@/features/authorization/authorization.routes').then((m) => m.AUTHORIZATION_ROUTES)
      }
    ],
    data: {
      isAnonymous: true
    },
    canActivateChild: [AuthenticationGuard]
  },
  {
    path: ROUTES.EMPTY_URL,
    component: ErrorLayoutComponent,
    children: [
      {
        path: ROUTES.EMPTY_URL,
        loadChildren: () => import('@/features/error/error.routes').then((m) => m.ERROR_ROUTES)
      }
    ]
  },
  {
    path: ROUTES.ZENITH_BILLING.path,
    component: AppLayoutComponent,
    children: [
      {
        path: ROUTES.EMPTY_URL,
        loadChildren: () =>
          import('@/features/zenith-billing/zenith-billing.routes').then((m) => m.ZENITH_BILLING_ROUTES)
      }
    ],
    data: {
      isAdminRoutes: false
    },
    canActivateChild: [AuthenticationGuard]
  },
  {
    path: ROUTES.SETTINGS.path,
    component: AppLayoutComponent,
    children: [
      {
        path: ROUTES.EMPTY_URL,
        loadChildren: () => import('@/features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES)
      }
    ],
    data: {
      isAdminRoutes: false
    },
    canActivateChild: [AuthenticationGuard]
  },
  {
    path: ROUTES.OTHERS,
    redirectTo: ROUTES.PAGE_404.path,
    pathMatch: RoutePathMatch.Full
  }
];
